var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { Avatar, Card, Checkbox } from '@philips-internal/oswald-ui-components/lib/components';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import { eventListener, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import radiologyLabIconSVG from '../../assets/images/avatars/radiology_lab.svg';
import laboratoryIconSVG from '../../assets/images/avatars/avatar_lab.svg';
import undefinedIconSVG from '../../assets/images/global/hpms-user.svg';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import CardExamsTitleAPI from './cad-exams-title-api';
import './card-exams-title.css';
let CardExamsTitle = class CardExamsTitle extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            data: {},
            visible: true,
            width: 12,
            check: false
        };
        this.onClickExam = () => {
            const { onClickExam } = this.props;
            if (isFunction(onClickExam)) {
                onClickExam(new ClickEvent({
                    value: {
                        onClickExam
                    }
                }));
            }
        };
    }
    render() {
        return (React.createElement(Card, { onClick: () => this.onClickExam(), width: 12, className: 'card-exams-title', selectionType: SelectionType.SINGLE, uuid: "4b0c63d4-c92b-4738-a106-5d174f557eaf" },
            this.getSvg(),
            this.renderContent()));
    }
    getSvg() {
        const { type } = this.props;
        if (type == 'L' || type == 'P') {
            return (React.createElement("div", { className: 'card-avatar-div' },
                React.createElement(Avatar, { image: laboratoryIconSVG })));
        }
        if (type == 'N') {
            return (React.createElement("div", { className: 'card-avatar-div' },
                React.createElement(Avatar, { image: radiologyLabIconSVG })));
        }
        return (React.createElement("div", { className: 'card-avatar-div' },
            React.createElement(Avatar, { image: undefinedIconSVG })));
    }
    onCheck() {
        this.setState({ check: !this.state.check });
        const { onSubmitCheck } = this.props;
        if (isFunction(onSubmitCheck)) {
            onSubmitCheck(new ClickEvent({
                value: {
                    onSubmitCheck
                }
            }));
        }
    }
    renderContent() {
        const { nmExame, type, nmPessoaFisica } = this.props;
        const exameName = type === 'L' ? MessageService.translate(nmExame) : nmExame;
        return (React.createElement("div", { className: 'card-content' },
            React.createElement("div", { className: 'card-left-content' },
                React.createElement("div", { className: 'content-exame-name' }, exameName),
                React.createElement("div", { className: 'content-physician-name' }, `${MessageService.translate('result.requested-by')} ${nmPessoaFisica}`)),
            React.createElement("div", { className: 'card-right-content' },
                React.createElement("div", { className: "c-check-checkbox" },
                    React.createElement(Checkbox, { uuid: '06be0a92-5d5e-4038-aac3-bf9245948ce5', name: '', label: `${MessageService.translate('result.filter-read')}`, onChange: () => this.onCheck(), value: this.state.check })))));
    }
};
CardExamsTitle.propTypes = {
    onClickExam: eventListener,
    nmExame: string,
    nmPessoaFisica: string,
    type: string,
    ieLido: string,
    fotoBase64: string,
    onSubmitCheck: eventListener,
};
CardExamsTitle = __decorate([
    AwesomeComponent({ type: ComponentType.DATA_DISPLAY, api: CardExamsTitleAPI })
], CardExamsTitle);
export default CardExamsTitle;
//# sourceMappingURL=card-exams-title.js.map